import React from "react";
import PropTypes from "prop-types";
// Limitless imports
import Grid from "@limitless/modern/layout/Grid";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Chip from "@limitless/modern/data-display/chip/Chip";
import Divider from "@limitless/modern/data-display/divider/Divider";
import { useExpertProfileContext } from "@limitless/expert";

const WithdrawlHistoryItem = ({ item, header, rdataDate, index }) => {
    const { formatCurrency } = useExpertProfileContext();

    const colourMap = (theme, state) => {
        switch (state) {
            case "failed":
                return theme.palette.error.light;
            case "requested":
                return theme.palette.secondary.light;
            case "paid":
                return theme.palette.secondary.light;
            case "cancelled":
                return theme.palette.error.light;
            default:
                return theme.palette.warning.light;
        }
    };

    return (
        <Grid item xs={12} id={"withdrawl-row-"} sx={{ minHeight: "fit-content" }}>
            <Grid container sx={{ rowGap: 2.5 }} alignItems="center" id={`withdrawalHistoryItem${index}`}>
                {header !== "" && (
                    <Grid item xs={12} component={Typography} variant="subtitle2" color="text.primary">
                        {header}
                    </Grid>
                )}
                <Grid
                    item
                    xs={4}
                    component={Typography}
                    variant="body2"
                    sx={{ paddingLeft: 1 }}
                    color="text.primary"
                    id={`withdrawalHistoryItemDate${index}`}
                >
                    {rdataDate}
                </Grid>
                <Grid item xs={4} sx={{ textAlign: "center" }}>
                    <Chip
                        label={item.displayState
                            .toLowerCase()
                            .replace(/\b\w/g, s => s.toUpperCase())
                            .replace("_", " ")}
                        sx={{
                            backgroundColor: theme => colourMap(theme, item.displayState.toLowerCase())
                        }}
                        id={`withdrawalHistoryItemState${index}`}
                    />
                </Grid>
                <Grid
                    item
                    xs={4}
                    component={Typography}
                    sx={{ textAlign: "right" }}
                    variant="subtitle2"
                    color="text.primary"
                    id={`withdrawalHistoryItemAmount${index}`}
                >
                    {formatCurrency(item.amount)}
                </Grid>
                <Grid item xs={12} component={Divider} sx={{ marginBottom: 2.5 }} />
            </Grid>
        </Grid>
    );
};

WithdrawlHistoryItem.propTypes = {
    item: PropTypes.object.isRequired,
    header: PropTypes.string,
    rdataDate: PropTypes.string,
    index: PropTypes.number
};

export default WithdrawlHistoryItem;
